import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$attrs.label || _vm.$t('Path'),"hide-details":"auto","outlined":"","prefix":"/"},model:{value:(_vm.path),callback:function ($$v) {_vm.path=$$v},expression:"path"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }